import { render, staticRenderFns } from "./BoundingBox.vue?vue&type=template&id=6eec2b1b&scoped=true"
import script from "./BoundingBox.vue?vue&type=script&lang=ts"
export * from "./BoundingBox.vue?vue&type=script&lang=ts"
import style0 from "./BoundingBox.vue?vue&type=style&index=0&id=6eec2b1b&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6eec2b1b",
  null
  
)

export default component.exports